import { render, staticRenderFns } from "./ProtocolEdit.vue?vue&type=template&id=8e3c91c2&"
import script from "./ProtocolEdit.vue?vue&type=script&lang=js&"
export * from "./ProtocolEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports